import { api } from './api';
import { UserProfile } from "../models/UserProfile";

export default class PasswordRecoveryService {

    static async sendEmail(emailOrUsername: string): Promise<void> {
        await api.post('/auth/password/recovery/email/send', { emailOrUsername });
    }

    static async validateCode(emailOrUsername: string, code: number): Promise<void> {
        const response = await api.get(`/auth/password/recovery/code/validate?emailOrUsername=${emailOrUsername}&code=${code}`);
        return response.data;
    }

    static async updatePassword(emailOrUsername: string, code: number, newPassword: string): Promise<void> {
        const response = await api.post('/auth/password/recovery/password/new/set', { emailOrUsername, code, newPassword });
        return response.data;
    }
} 